import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "./CheckOutForm";
import { useLocation } from "react-router-dom";

const StripePayment = () => {
  const location = useLocation();
  const { clientSecret, key ,transactionId,isSetupIntent} = location.state || {};

  //  const publishableKey = 'pk_test_51QjJtmDCxXbmTNTWJj0fNDX392eYUhtUKrllvSuPBZAy8TyV54KnFmvFkrZ8W6zbNt9fgrCOclrOvgcLc8BqsJwG007ExHJF3u';
  // const publishableKey ="pk_test_51Qvw8xK9jZ0m6dC5Q1CeJZSj7g1YlEs9G7YhHoSuIPlcdYFRTz0GTPckpKn7KMTVeYao2vnhPw5jrbhLmqiRRo8S00QMreJOKA";
  // const publishableKey = "pk_test_51Qvw8xK9jZ0m6dC5Q1CeJZSj7g1YlEs9G7YhHoSuIPlcdYFRTz0GTPckpKn7KMTVeYao2vnhPw5jrbhLmqiRRo8S00QMreJOKA"
  const publishableKey  = 'pk_test_51QjJtmDCxXbmTNTWJj0fNDX392eYUhtUKrllvSuPBZAy8TyV54KnFmvFkrZ8W6zbNt9fgrCOclrOvgcLc8BqsJwG007ExHJF3u'
  const stripePromise = loadStripe(publishableKey);

  const appearance = {
    theme: "stripe",
  };

  const options = {
    clientSecret,
    appearance,
    key,
    isSetupIntent
  };

  return (
    <div>
      {clientSecret && (
        <Elements options={ options } stripe={ stripePromise }>
          <CheckoutForm clientSecret={ clientSecret }/>
        </Elements>
      )}
    </div>
  );
};

export default StripePayment;
